import { render } from "./SquadInput.vue?vue&type=template&id=02671c8a&scoped=true"
import script from "./SquadInput.vue?vue&type=script&lang=js"
export * from "./SquadInput.vue?vue&type=script&lang=js"

import "./SquadInput.vue?vue&type=style&index=0&id=02671c8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02671c8a"]])

export default __exports__